import { render, staticRenderFns } from "./Water-outage-management.vue?vue&type=template&id=66b2d0b2&scoped=true"
import script from "./Water-outage-management.vue?vue&type=script&lang=js"
export * from "./Water-outage-management.vue?vue&type=script&lang=js"
import style0 from "./Water-outage-management.vue?vue&type=style&index=0&id=66b2d0b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b2d0b2",
  null
  
)

export default component.exports